module.exports = __webpack_public_path__ + "static/media/copy.de2b93ed.svg";